import { z } from 'zod'
import { emailSchema } from '../validators/email.validator.js'

const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .transform((value) => (value === '' ? null : value))
    .nullish()

/**
 * Contact email is optional but validated when present — a contact we only have
 * a phone number for is normal, an unusable email address is not.
 *
 * Phone is intentionally loose: extensions, formatting, and international
 * numbers all show up in practice, and a strict pattern would reject real data
 * for no benefit.
 */
export const createContactInputSchema = z
  .object({
    name: z.string().trim().min(1, 'Name is required').max(200),
    title: optionalText(120),
    email: emailSchema
      .transform((value) => (value === '' ? null : value))
      .nullish(),
    phone: optionalText(50),
    isPrimary: z.boolean().optional(),
    notes: optionalText(5000),
  })
  .strict()

export type CreateContactInput = z.infer<typeof createContactInputSchema>

export const updateContactInputSchema = createContactInputSchema
  .partial()
  .strict()

export type UpdateContactInput = z.infer<typeof updateContactInputSchema>
